import DUIForm from './dui-form';
import PersonalInjuryForm from './pi-form';
import OtrForm from './otr-form';

$(document).ready(function () {
  (new DUIForm).validate();
  (new PersonalInjuryForm).validate();
  (new OtrForm).validate();
});



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-lawyers/index.js